import React from 'react';
import clsx from 'clsx';

import { StandardProps } from '../../types/common';

import styles from './Avatar.module.scss';

import DEFAULT_AVATAR from './avatar-default.png';

export interface AvatarProps extends StandardProps {
  /**
   * Alt text for the avatar image
   */
  alt: string;

  /**
   * Source for the avatar image
   */
  src?: string;

  /**
   * Size of the avatar
   */
  size?: 'xxxs' | 'xxs' | 'xs' | 's' | 'xm' | 'm' | 'l';
}

export const Avatar = ({
  src = DEFAULT_AVATAR,
  alt,
  size = 'm',
  className,
  testid = 'avatar',
}: AvatarProps): JSX.Element => {
  return (
    <div
      className={clsx(
        styles['hds-avatar'],
        styles[`hds-avatar_size_${size}`],
        className
      )}
      aria-label={alt}
      style={{ backgroundImage: `url(${src})` }}
      data-testid={testid}
    />
  );
};
